import ValueObject from 'src/app/core/domain/value_object';

export enum PaymentMethodType {
  Card = 'card',
  Sepa = 'sepa',
}

export interface PaymentMethodProps {
  id: string;
  type: PaymentMethodType;
  owner?: string;
  cardBrand?: string;
  cardLast4Digits?: string;
  sepaBankCode?: string;
  expMonth: number | undefined;
  expYear: number | undefined;
  default: boolean;
}

export class PaymentMethod extends ValueObject<PaymentMethodProps> {
  get id(): string {
    return this.props.id;
  }

  get type(): PaymentMethodType {
    return this.props.type;
  }

  get owner(): string | undefined {
    return this.props.owner;
  }

  get cardBrand(): string | undefined {
    return this.props.cardBrand;
  }

  get cardLast4Digits(): string | undefined {
    return this.props.cardLast4Digits;
  }

  get sepaBankCode(): string | undefined {
    return this.props.sepaBankCode;
  }

  get expMonth(): number | undefined {
    return this.props.expMonth;
  }

  get expYear(): number | undefined {
    return this.props.expYear;
  }

  get default(): boolean {
    return this.props.default;
  }

  set default(value: boolean) {
    this.props.default = value;
  }

  private constructor(props: PaymentMethodProps) {
    super(props);
  }

  public static create(props: PaymentMethodProps): PaymentMethod {
    return new PaymentMethod(props);
  }
}
